export function cloneDeep(object: any) {
    if (object) {
        // TODO: Is this an efficient method?   Rewrite to be faster?
        return JSON.parse(JSON.stringify(object));
    }
    return null;
}

export function wait(seconds: number) {
    return new Promise((r, j) => setTimeout(r, seconds * 1000));
}

export function generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}

// Test to see if object is empty
export function isEmptyObject(obj) {
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            return false;
        }
    }
    return true;
}

export class HtmlElementPostionType {
    x: number;
    y: number;
    ancestor: HTMLElement;
}

export function getHtmlElementPosition(el, anchorClass: string = null): HtmlElementPostionType {
    //gets the x/y position of an element relative to a parent with a specific class tag.   If no class is specified the position will be relative to the viewport.
    //also returns the ancestor htlm element.  If not specified the "body" element will be returned.
    //if anchorClass omitted then absolute position in viewport is returned
    //if anchorClass provided then position relative to nearest ancestor with class containing the anchorClass is returned.
    //if anchorClass provided and no ancestore with anchorClass found then (x:0,y:0) returned

    var xPos = 0;
    var yPos = 0;
    var ancestor: HTMLElement = null;

    while (el) {
        if (anchorClass && el.classList.contains(anchorClass)) {
            ancestor = el;
            //stop walking up tree if ancestor is found with anchorClass-- return offset relative to parent rather than viewport
            break;
        }
        if (el.tagName == 'BODY') {
            if (!anchorClass) {
                ancestor = el; //set relative parent to body
            }
            // deal with browser quirks with body/window/document and page scroll
            var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
            var yScroll = el.scrollTop || document.documentElement.scrollTop;

            xPos += el.offsetLeft - xScroll + el.clientLeft;
            yPos += el.offsetTop - yScroll + el.clientTop;
        } else {
            // for all other non-BODY elements
            xPos += el.offsetLeft - el.scrollLeft + el.clientLeft;
            yPos += el.offsetTop - el.scrollTop + el.clientTop;
        }

        el = el.offsetParent;
    }

    return {
        x: xPos,
        y: yPos,
        ancestor: ancestor
    };
}

export function groupBy(keys, array) {
    return array.reduce(function (objectsByKeyValue, obj) {
        var value = keys
            .map(function (key) {
                return obj[key];
            })
            .join('-');
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
    }, {});
}
